import api from './api';

export interface UserManagementUser {
  id: number;
  name: string;
  email: string;
  role: string;
  active: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateUserPayload {
  name: string;
  email: string;
  password: string;
  role: string;
  active: boolean;
}

export interface UpdateUserPayload {
  name?: string;
  email?: string;
  role?: string;
  active?: boolean;
}

export const getAllUsers = async (): Promise<UserManagementUser[]> => {
  const response = await api.get('/admin/users');
  return response.data?.data || [];
};

export const getUserById = async (id: number): Promise<UserManagementUser> => {
  const response = await api.get(`/admin/users/${id}`);
  return response.data?.data;
};

export const createUser = async (payload: CreateUserPayload): Promise<UserManagementUser> => {
  const response = await api.post('/admin/users', payload);
  return response.data?.data;
};

export const updateUser = async (id: number, payload: UpdateUserPayload): Promise<UserManagementUser> => {
  const response = await api.put(`/admin/users/${id}`, payload);
  return response.data?.data;
};

export const updateUserStatus = async (id: number, active: boolean): Promise<UserManagementUser> => {
  const response = await api.patch(`/admin/users/${id}/status`, { active });
  return response.data?.data;
};

export const deleteUser = async (id: number): Promise<void> => {
  await api.delete(`/admin/users/${id}`);
};
